import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { computed } from '@ember/object';
import Money from './money';
import { OfflinePaymentOption } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/settings/common/store_and_forward';
export default ProtoBaseModel.extend({
  enabled: attr(Boolean),
  // deprecated
  singleTransactionLimit: attr(Money),
  squareOutagePaymentOption: attr(OfflinePaymentOption),
  networkOutagePaymentOption: attr(OfflinePaymentOption),
  displayValueTranslationKey: computed('enabled', 'networkOutagePaymentOption', 'squareOutagePaymentOption', function () {
    if (this.squareOutagePaymentOption || this.networkOutagePaymentOption) {
      return null;
    }
    return this.enabled ? 'business.devices.profiles.v2.settings.checkout.offlineMode.enabled.displayValue.on' : 'business.devices.profiles.v2.settings.checkout.offlineMode.enabled.displayValue.off';
  })
});